import { useState, useEffect, React } from "react";
import $ from 'jquery';
// core components
import './Contact.css';
import Footer from "../Footer/Footer.js";
import Loader from "../../components/loader/loader.js";
import About from "../../assets/images/about.png"
import Support from "../../assets/images/support.png"
import Education from "../../assets/images/Education.png"
import Empower from "../../assets/images/empower.png"
import Adopt from "../../assets/images/adopt.png"
import Health from "../../assets/images/Health.png"
import Public from "../../assets/images/Public.png"
import {Link} from "react-router-dom";

export default function Home() {
   const [loading, setLoading] = useState(true);
 
   useEffect(() => {
     const timer = setTimeout(() => {
       setLoading(false);
     }, 2500); 
 
     return () => clearTimeout(timer);
   }, []);
   $(window).scroll(function () {
    if ($(this).scrollTop()) {
      $('header').addClass('fixedTop');
    } else {
      $('header').removeClass('fixedTop');
    }
  });
  useEffect(() => {
     window.scrollTo(0, 0)
   }, [])
  return (
<div>
{loading ? <Loader /> :
    <div>
        <div className="vision_header">
          <section className="vision_banner">
            <div className="container-fluid custom-container">
               <div className="row">
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_text">
                        <h1>CONTACT US</h1>
                       </div>
                  </div>
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_img">
                     <img src={About} alt="about" className="img-fluid"/>
                     </div>
                  </div>
               </div>
               </div>
            
                  
            </section>
           <section className="contact_us mt-4 pt-5">
            <div className="container-fluid custom_container_inner">
                <h2>Contact Us</h2>
              
                     <div className="Contact_us_text">
                        <h3>Address</h3>
                        <p>30-110 vaikasi street chinmaya nagar Virugambakkam, 
Chennai 600092,
Tamil Nadu,
Indian.</p>
                     </div>
                     <div className="Contact_us_text">
                        <h3>Email ID</h3>
                        <p> jayamcharitabletrust01@gmail.com</p>
                     </div>
                     <div className="Contact_us_text">
                        <h3>Mobile Number</h3>
                        <p> +91 99770 97552 </p>
                     </div>
                  
                
                  
              
            </div>         
           </section>
                  
           <Footer />
        </div>
     
    </div>
    }
    </div>
  )
}
